import { render, staticRenderFns } from "./listMultiChoiceProps.vue?vue&type=template&id=985d9b78&"
import script from "./listMultiChoiceProps.vue?vue&type=script&lang=js&"
export * from "./listMultiChoiceProps.vue?vue&type=script&lang=js&"
import style0 from "./listMultiChoiceProps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VChip,VIcon,VTextField})
